import { render, staticRenderFns } from "./AssessmentMemberModal.vue?vue&type=template&id=b0ac7328&"
import script from "./AssessmentMemberModal.vue?vue&type=script&lang=js&"
export * from "./AssessmentMemberModal.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentMemberModal.vue?vue&type=style&index=0&id=b0ac7328&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports